import { createStyles } from '@material-ui/core';

const styles = (theme) =>
  createStyles({
    headerContainer: {
      backgroundColor: theme.palette.header.background,
      zIndex: theme.zIndex.drawer + 1,
      width: '100%',
      position: 'fixed',
    },
    mainHeaderContainer: {
      alignItems: 'center',
      justifyContent: 'space-between',
      width: '100%',
      alignSelf: 'center',
      padding: '14px 20px',
      [theme.breakpoints.down('sm')]: {
        padding: '12px',
      },
    },
    subHeaderContainer: {
      boxShadow: '0px 16px 16px -16px #21212140',
      padding: '0 16px 0',
      justifyContent: 'end',
      backgroundColor: theme.palette.header.subHeaderBackground,
    },
    logoContainer: {
      display: 'flex',
      alignItems: 'center',
      backgroundColor: 'transparent',
      border: 'none',
      height: 40,
    },
    logo: {
      height: 32,
      [theme.breakpoints.down('sm')]: {
        height: 28,
      },
    },
  });

export default styles;
